import React from "react";
import road from "../../assets/images/newpages/road.png";
import joruneyOne from "../../assets/images/journey-one.png";
import joruneyTwo from "../../assets/images/journey-two.png";
import joruneyThree from "../../assets/images/journey-three.png";
import car from "../../assets/images/journey-car.png";
import { Row, Col } from "react-bootstrap";

const NewLicenseJoruney = ({ heading, cardContent }) => {
  return (
    <section className="keyzi_mind--wrapper keyzi_newJourney--wrapperNew">
      <div className="container">
        <div className="keyzi_mind--inner">
          <h2 className="mb-5">{heading || "Online - Flexible - Affordable. It's Easy As . . ."}</h2>
          <div className="journey--cards--wrapper">
            {cardContent ? (
              cardContent.map((e, index) => (
                <div key={index} className="journey--card">
                  <div className="card-img">
                    <img
                      src={`https://keyzi.com.au/keyzi-admin/public${e.image}`}
                      alt={e.image_attribute
                        || "Journey Image"}
                      className="img-fluid"
                    />
                  </div>
                  <div className="card-content">
                    <h5>{e.title}</h5>
                    <p>{e.description}</p>
                  </div>
                </div>
              ))
            ) : (
              <>
                <div className="journey--card">
                  <div className="card-img">
                    <h1>1</h1>
                  </div>
                  <div className="card-content">
                    <h5>Choose Your Instructor</h5>
                    <p>Browse local instructors and see ratings and hear feedback from other learners.</p>
                  </div>
                </div>
                <div className="journey--card">
                  <div className="card-img">
                  <h1>2</h1>
                  </div>
                  <div className="card-content">
                    <h5>Select A Lesson</h5>
                    <p>Book lessons online or reschedule 24/7 with instant confirmation.</p>
                  </div>
                </div>
                <div className="journey--card">
                  <div className="card-img">
                   <h1>3</h1>
                  </div>
                  <div className="card-content">
                    <h5>Start Driving</h5>
                    <p>
                    Your instructor will arrive at your chosen pick-up location to start your lesson.
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewLicenseJoruney;
